/** Occupies a colony tile's slot once a player has sold their colony there (see the Colony
 * Sale card): the slot stays filled - it can't be built on again - but doesn't belong to any
 * real player, so it's excluded from every player-identity check against `Colony.colonies`. */
export const NEUTRAL_COLONY_OWNER = 'pNEUTRAL';
export function isPlayerId(object) {
    return object?.charAt?.(0) === 'p';
}
export function isGameId(object) {
    return object?.charAt?.(0) === 'g';
}
export function isSpectatorId(object) {
    return object?.charAt?.(0) === 's';
}
export function isSpaceId(object) {
    return /^([cm][0-9]{2}|[0-9]{2,3})$/.test(object);
}
export function safeCast(object, tester) {
    if (tester(object)) {
        return object;
    }
    throw new Error('failed cast: ' + tester.name);
}
